import { Controller } from '@hotwired/stimulus'

// El título de la pestaña en la comparativa de ETFs (`comparar.haml`). Añadir, quitar o cambiar un ETF cambia solo
// el turbo-frame de la comparativa, y el script que pone el título en cada navegación (`_head_metadata.haml`) va
// fuera de él: sin esto la pestaña seguiría diciendo los ETF de antes.
export default class extends Controller {
  static values = { titulo: String }

  connect () {
    this.poner = () => { if (document.title !== this.tituloValue) document.title = this.tituloValue }
    this.poner()
    // Ese script vuelve a poner el título con el que se cargó la página en cada `turbo:frame-render`, también el
    // de este frame y el del gráfico, que llega después de conectar. Se escuchó antes que este, así que este gana.
    document.addEventListener('turbo:frame-render', this.poner)
  }

  disconnect () {
    document.removeEventListener('turbo:frame-render', this.poner)
  }
}
